// extracted by mini-css-extract-plugin
export default {"Content":"AuthorTabs_Content__kQeXM","TabBar":"AuthorTabs_TabBar__RJcxq"};